export default function createPersistAsteсPaginacaoPlugin(secureLS) {
  return store => {
    const PAGINATION_KEYS = {
      GENERICA: "astec_paginacao",
      PROJETOS: "astec_paginacao_projetos",
      CLIENTE_RURAL: "astec_paginacao_cliente_rural",
      PROJETO_POR_LOTE: "astec_paginacao_projeto_por_lote"
    };

    const NAMESPACE_TO_KEY = {
      "astec/paginacao/paginacaoProjetos": PAGINATION_KEYS.PROJETOS,
      "astec/paginacao/paginacaoGenerica": PAGINATION_KEYS.GENERICA,
      "astec/paginacao/paginacaoClienteRural": PAGINATION_KEYS.CLIENTE_RURAL,
      "astec/paginacao/paginacaoProjetoPorLote":
        PAGINATION_KEYS.PROJETO_POR_LOTE
    };

    const restorePagination = (namespace, storageKey) => {
      try {
        const saved = secureLS
          ? secureLS.get(storageKey)
          : localStorage.getItem(storageKey);

        if (saved) {
          const parsed = JSON.parse(saved);
          const umDia = 24 * 60 * 60 * 1000;

          if (Date.now() - parsed.timestamp < umDia) {
            if (store.state.astec?.paginacao) {
              const moduleName = namespace.split("/").pop();

              if (store.state.astec.paginacao[moduleName]) {
                store.commit(`${namespace}/SET_PAGE`, parsed.currentPage || 1);
                store.commit(
                  `${namespace}/SET_PAGE_SIZE`,
                  parsed.pageSize || 10
                );
              }
            }
          } else {
            if (secureLS) {
              secureLS.remove(storageKey);
            } else {
              localStorage.removeItem(storageKey);
            }
          }
        }
      } catch (error) {
        console.warn(`Erro ao restaurar paginação para ${namespace}:`, error);
      }
    };

    const savePagination = (namespace, storageKey, state) => {
      const estadoParaSalvar = {
        currentPage: state.currentPage,
        pageSize: state.pageSize,
        timestamp: Date.now()
      };

      try {
        if (secureLS) {
          secureLS.set(storageKey, JSON.stringify(estadoParaSalvar));
        } else {
          localStorage.setItem(storageKey, JSON.stringify(estadoParaSalvar));
        }
      } catch (error) {
        console.warn(`Erro ao salvar paginação para ${namespace}:`, error);
      }
    };

    Object.entries(NAMESPACE_TO_KEY).forEach(([namespace, storageKey]) => {
      restorePagination(namespace, storageKey);
    });

    store.subscribe((mutation, state) => {
      const namespace = mutation.type
        .split("/")
        .slice(0, 3)
        .join("/");
      const storageKey = NAMESPACE_TO_KEY[namespace];

      if (
        storageKey &&
        (mutation.type.includes("/SET_PAGE") ||
          mutation.type.includes("/SET_PAGE_SIZE"))
      ) {
        const moduleName = namespace.split("/").pop();
        const paginacao = state.astec?.paginacao?.[moduleName];

        if (paginacao) {
          savePagination(namespace, storageKey, paginacao);
        }
      }
    });
  };
}
